module.exports = __webpack_public_path__ + "static/media/signup-theme-bg.7bb51af5.png";